export const TypeSale = {
    venda: "Venda",
    orcamento: "Orçamento",
    frenteDeCaixa: "Frente de caixa",
    orcamentoMtq: "Orçamento MT2",
    vendaMtq: "Venda MT2",
}